
const digest = 'b31379abc3ce01164555b316304cd0c524737cdbd5be2cdbf3960b3a7be0dd40';
const classes = {"container":"_container_1t82x_1","dropdown":"_dropdown_1t82x_5"};
const css = `._container_1t82x_1 {
  position: relative;
}

._dropdown_1t82x_5 {
  position: absolute;
  z-index: 5;
  width: 100%;
  background: #fff;
  border: 1px solid #e2e5ed;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-top: 4px;
  max-height: 240px;
  overflow-y: auto;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  